import { ServiceBase } from '../../../../../core/services/ServiceBase'
import ScoreCompanyProxy from './proxy'

class ScoreCompanyService extends ServiceBase {
  getHightLight(params) {
    return this.getData(() => ScoreCompanyProxy.getHightLight(params))
  }
  getModelLists(params) {
    return this.getData(() => ScoreCompanyProxy.getModelLists(params))
  }
  //Score Credit Risk
  getScoreCreditRisk(params) {
    return this.getData(() => ScoreCompanyProxy.getScoreCreditRisk(params))
  }
  getTrendOfScore(params) {
    return this.getData(() => ScoreCompanyProxy.getTrendOfScore(params))
  }
  getDistributionScore(params) {
    return this.getData(() => ScoreCompanyProxy.getDistributionScore(params))
  }

  //ScoreRangesPerformance
  getScorePerformance(params) {
    return this.getData(() => ScoreCompanyProxy.getScorePerformance(params))
  }
  getTrendOfScorePerformance(params) {
    return this.getData(() =>
      ScoreCompanyProxy.getTrendOfScorePerformance(params),
    )
  }
  getDistributionPerformance(params) {
    return this.getData(() =>
      ScoreCompanyProxy.getDistributionPerformance(params),
    )
  }

  //CorporateLinkageScore
  getLinkageScore(params) {
    return this.getData(() => ScoreCompanyProxy.getLinkageScore(params))
  }
  downloadLinkageScore(params) {
    return this.getFileDownload(() =>
      ScoreCompanyProxy.downloadLinkageScore(params),
    )
  }
}

export default new ScoreCompanyService()
